import {
  propToBackgroundColor,
  stylesUnlessPropTrue,
} from '@sleepstation/style-api-helpers'
import { reversedTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import styled, { ThemeProvider, css } from 'styled-components'
import PageNavContainer from '../../../../../state/PageNavContainer'
import AppBody from '../../AppBody'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  min-height: 100vh;
  ${propToBackgroundColor(`bgColour`)}

  ${stylesUnlessPropTrue(
    `headerIsFixed`,
    css`
      display: flex;
      flex-direction: column;
    `
  )}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const RootLayout = ({ children, logoutPath }) => {
  const [nav] = PageNavContainer.useContainer()

  const {
    pageId,
    headerIsFixed,
    backgroundIsHidden,
    Header,
    accoundNavIsHidden,
    pageBackgroundColour,
  } = nav
  const pageDataCy = `${pageId}Page`

  return (
    <Layout
      headerIsFixed={headerIsFixed}
      data-cy={pageDataCy}
      bgColour={pageBackgroundColour}
      example={`danger`}
    >
      <ScrollRestoration />
      {Header && (
        <ThemeProvider theme={reversedTheme}>
          <Header
            isFixed={headerIsFixed}
            logoutPath={logoutPath}
            hideBackground={backgroundIsHidden}
            accoundNavIsHidden={accoundNavIsHidden}
          />
        </ThemeProvider>
      )}
      <AppBody headerIsFixed={headerIsFixed}>{children || <Outlet />}</AppBody>
    </Layout>
  )
}

RootLayout.propTypes = {
  children: PropTypes.node,
  logoutPath: PropTypes.string.isRequired,
}

RootLayout.defaultProps = {
  children: undefined,
}

export default RootLayout
